import { render } from "./NcrmPrivacyPurposeLink.vue?vue&type=template&id=45aa4248&scoped=true"
import script from "./NcrmPrivacyPurposeLink.vue?vue&type=script&lang=js"
export * from "./NcrmPrivacyPurposeLink.vue?vue&type=script&lang=js"

import "./NcrmPrivacyPurposeLink.vue?vue&type=style&index=0&id=45aa4248&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45aa4248"]])

export default __exports__